import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Button } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './OperationNotAllowed.css';
import { closeModal, ModalActions } from '../../actions/modalActions';

interface OperationNotAllowedProps {
  closeModal: (index?: number) => void;
  index?: number;
}

export const OperationNotAllowed = ({
  index, closeModal: closeModalProp
}: OperationNotAllowedProps) => (
  <div data-test-id="operation-not-allowed-modal">
    <div className={styles.title}>{getMessage('operationModal.title')}</div>
    <p data-test-id="operation-modal-text">{getMessage('operationModal.text')}</p>
    <div className={styles.buttonContainer}>
      <Button mode="link" onClick={() => closeModalProp(index)} data-test-id="operation-modal-ok-button">
        {getMessage('operationModal.ok')}
      </Button>
    </div>
  </div>
);

function mapDispatchToProps(dispatch: Dispatch<ModalActions>) {
  return bindActionCreators(
    {
      closeModal,
    },
    dispatch
  );
}

export default connect(undefined, mapDispatchToProps)(OperationNotAllowed);
